import { gqlClient } from 'src/common/services/api/GraphQLRequestApi';
import { Logger } from 'src/common/services/Logger';

import {
	IUniqueIssuesFilterOptions,
	transformUniqueIssuesFilterOptions
} from '../queries/unique-issues-filters/helpers/transformResults';
import { GetUniqueIssuesFilterOptionsQuery } from '../queries/unique-issues-filters/UniqueIssuesFilterOptions.generated';
import { GetUniqueIssuesFilterOptions } from '../queries/unique-issues-filters/UniqueIssuesFilterOptions.gql';

export const getUniqueIssuesFilterOptions = async (): Promise<IUniqueIssuesFilterOptions> => {
	try {
		const result = await gqlClient.request<GetUniqueIssuesFilterOptionsQuery>(
			GetUniqueIssuesFilterOptions
		);

		const transformedResult = transformUniqueIssuesFilterOptions(result);
		return transformedResult;
	} catch (e) {
		Logger.error('UniqueIssuesFilterOptionsService -> getUniqueIssuesFilterOptions failed:', e);
		throw e;
	}
};
